import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AdvancedAlertsPage, { getDefaultPageUI } from "components/pages/AdvancedAlertsPage";
import AddAlertContent from "components/pages/AdvancedAlertsPage/components/AddAlertContent";
import Classes from "model";

export default function CaptureNotifiLegacyAddAlert(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    // Sets the component to be used for the content
    .update([ "content" ], AddAlertContent)
    .submit();
    
    return <AdvancedAlertsPage ui={ ui } />
}